"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supplyNow = exports.formatDueDateString = void 0;
var date_fns_1 = require("date-fns");
function formatDueDateString(date, today, dateFormat) {
    if (dateFormat === void 0) { dateFormat = 'E, MMM. d'; }
    return (0, date_fns_1.isSameDay)(date, today) ? 'Due Today' : 'Due ' + (0, date_fns_1.format)(date, dateFormat);
}
exports.formatDueDateString = formatDueDateString;
function supplyNow() {
    return new Date();
}
exports.supplyNow = supplyNow;
